import React, { useState } from 'react';
import { Table } from 'semantic-ui-react';
import ColumnResizer from "react-column-resizer";

import { TableAddColumn } from './AddColumn'


export function TableHeader(props) {
    //To hide the resource pane
    function headerRowClicked() {
        props.headerClickHideResourcePane()
    }

    return (
        <Table.Header>
            <Table.Row className="table-header" onClick={headerRowClicked} >
                {props.tableHeader && props.tableHeader
                    .filter((ft, i) => { return ft.listed })
                    .map((item, i) => {
                        let itemKey = item.key && typeof (item.key) === 'object' ? item.key[0] : item.key
                        return <React.Fragment key={i}>
                            <Table.HeaderCell
                                key={i}
                                sorted={item.sortable && props.key === itemKey ? props.direction : null}
                                onClick={item.sortable ? () => props.handleSort(itemKey) : null}
                                width={item.style && item.style.width ? item.style.width : null}
                                textAlign={itemKey === "action" ? 'right' : 'left'}
                                className={`table-cell-header ${itemKey === props.column ? "active" : null}`}
                            >
                                <div className="float-left w_100" className="FilterHeader" style={{ lineHeight: "22px" }}>
                                    <React.Fragment>
                                        <TableAddColumn
                                            item={item}
                                            tableHeader={props.tableHeader}
                                            addColumn={props.addColumn}
                                            direction={props.direction}
                                            column={props.column}
                                            showFilterHeader={props.showFilterHeader}
                                            resetFilter={props.resetFilter}
                                            downloadAsCSV={props.downloadAsCSV}
                                            changeMenuView={props.changeMenuView}
                                            actionType={props.actionType}
                                            csvData={props.csvData}
                                            headerClickHideResourcePane={props.headerClickHideResourcePane}
                                            handleTableComponent={props.handleTableComponent}
                                            defaultMarkAll={props.defaultMarkAll}
                                        />
                                    </React.Fragment>
                                </div>
                            </Table.HeaderCell>
                            {
                                props.tableHeader.length - 1 === i ? null :
                                    <ColumnResizer className="columnResizer" minWidth={0} />
                            }
                        </React.Fragment>
                    })}
            </Table.Row>
        </Table.Header>
    );
}